export default __webpack_public_path__ + "static/media/waiting.6c3b759f.svg";